export const ROUTE_ROOT = "/";
export const ROUTE_EMPLOYEES = "/employees";
export const ROUTE_MY_EVENTS = "/agenda";
export const ROUTE_INSURERS_CONTRACTS = "/insurers/contracts";
export const ROUTE_INSURERS_PACKAGES = "/admin/insurers/packages";
export const ROUTE_ADMIN_ANALYTICS = "/admin/analytics";
export const ROUTE_ADMIN_IMPORTS = "/admin/imports";
export const ROUTE_ADMIN_IMPORTS_EMPLOYEES = "/admin/imports/employees";
export const ROUTE_ADMIN_ANNOUNCEMENTS = "/admin/announcements";
export const ROUTE_ADMIN_ZORGTOPICS = "/admin/zorgtopics";
export const ROUTE_ADMIN_ZORGTOPICS_CARE_PLANS = "/admin/zorgtopics/care-plans";
export const ROUTE_ADMIN_ZORGTOPICS_CARE_PLAN_NEW = "/admin/zorgtopics/care-plans/new";
export const ROUTE_ADMIN_ZORGTOPICS_PRACTICES = "/admin/zorgtopics/practices";
export const ROUTE_ADMIN_ZORGTOPICS_CHECKLISTS = "/admin/zorgtopics/checklists";
export const ROUTE_ADMIN_ZORGTOPICS_CHECKLIST_NEW = "/admin/zorgtopics/checklists/new";
export const ROUTE_ORGANIZATIONS = "/organizations";
export const ROUTE_MY_DAY = "/my-day";
export const ROUTE_MESSAGES = "/messages";
export const ROUTE_PATIENTS = "/patients";
export const ROUTE_START_DASHBOARD = "/start";
export const ROUTE_PLANNER = "/planner";
export const ROUTE_SWITCHER = "/switcher";
export const ROUTE_ONBOARDING = "/onboarding";
export const ROUTE_DECLARATION = "/declarations";
export const ROUTE_TASKSLIST = "/declarations/taskslist";
export const ROUTE_RATES = "/declarations/rates";
export const ROUTE_BILLING_SETTINGS = "/billing/settings";
export const ROUTE_TASKS_TABLE = "/tasks";
export const ROUTE_DECLARATION_DASHBOARD = "/declarations/dashboard";
export const ROUTE_DECLARATION_BATCHES = "/declarations/batches";
export const ROUTE_INVOICE_RETURNS = "/declarations/returns";
export const ROUTE_DECLARATION_CREDIT_REQUESTS = "/declarations/credit-requests";
export const ROUTE_DECLARATION_ACCOUNTING_SYNCS = "/declarations/accounting-syncs";
export const ROUTE_INTEGRATIONS = "/integrations";
export const ROUTE_EMBED_CONFIGURATIONS = "/embed-configurations";
export const ROUTE_EMBED_APPOINTMENT_MAKER = "embed-appointment-maker-uuid";
export const ROUTE_EMBED_PAYMENT_STATUS = "payment-status-invoiceId";
export const ROUTE_INTAKE_QUESTIONNAIRES = "vragenlijsten-token";
/** Pages a visitor opens without logging in; the global middleware leaves them alone. */
export const PUBLIC_ROUTE_NAMES: readonly string[] = [
  ROUTE_EMBED_APPOINTMENT_MAKER,
  ROUTE_EMBED_PAYMENT_STATUS,
  ROUTE_INTAKE_QUESTIONNAIRES,
];
export const ROUTE_LOGIN = "/login";
export const ROUTE_INTAKE_JOURNALS = "/intake-journals";
export const ROUTE_TREATMENT_JOURNALS = "/treatment-journals";
export const ROUTE_OPEN_JOURNALS = "/open-journals";
export const ROUTE_WEBPLANNER_APPOINTMENTS = "/webplanner-appointments";
export const ROUTE_PATIENT_SUBSCRIPTIONS = "/patient-subscriptions";
export const ROUTE_CONCERN_CONTRACTS = "/concern-contracts";
export const ROUTE_PROM_MANAGE = "/prom-manage";
export const ROUTE_GROUP_TEMPLATES = "/group-templates";
export const ROUTE_QUALITY_PROCESS_INDICATORS = "/quality-management/process-indicators";
export const ROUTE_QUALITY_OUTCOME_INDICATORS = "/quality-management/outcome-indicators";
export const ROUTE_QUALITY_TREATMENTS = "/quality-management/treatments";
export const ROUTE_QUALITY_REVENUE = "/quality-management/revenue";
export const ROUTE_QUALITY_CAPACITY = "/quality-management/capacity";
export const ROUTE_AUDIT_LOGS = "/audit-logs";
export const ROUTE_IDENTIFIERS = "/identifiers";
export const ROUTE_PLAN_APPOINTMENT = "/plan-appointment";

export const routeToPatient = (patientId: number | string) => `${ROUTE_PATIENTS}/${patientId}`;
export const routeToPatientProfile = (patientId: number | string) => `${ROUTE_PATIENTS}/${patientId}/profile`;
export const routeToPatientTreatment = (patientId: number | string, treatmentId: number | string) =>
  `${ROUTE_PATIENTS}/${patientId}/treatment/${treatmentId}`;
export const routeToPatientIntake = (patientId: number | string, intakeId: number | string) =>
  `${ROUTE_PATIENTS}/${patientId}/intakes/${intakeId}`;
export const routeToPatientIdentifiers = (patientId: number | string) => `${ROUTE_PATIENTS}/${patientId}/identifiers`;
export const routeToZorgtopicsCarePlan = (carePlanId: string) => `${ROUTE_ADMIN_ZORGTOPICS_CARE_PLANS}/${carePlanId}`;
export const routeToZorgtopicsChecklist = (checklistId: string) =>
  `${ROUTE_ADMIN_ZORGTOPICS_CHECKLISTS}/${checklistId}`;

export const ROUTE_TRAJECTORIES = "/trajectories";
export const ROUTE_REFERRALS = "/referrals";
export const ROUTE_ZORGMAIL_MESSAGES = "/zorgmail-messages";
export const ROUTE_MY_ORGANIZATION = "/my-organization";
/** A practice of the current organization, or with `organizationId` of any organization (admin). */
export const routeToPractice = (practiceId: string, organizationId?: string) =>
  organizationId
    ? `${ROUTE_ORGANIZATIONS}/${organizationId}/practices/${practiceId}`
    : `${ROUTE_MY_ORGANIZATION}/practices/${practiceId}`;
/** The practice overview the detail page returns to. */
export const routeToPractices = (organizationId?: string) =>
  organizationId ? `${ROUTE_ORGANIZATIONS}/${organizationId}` : `${ROUTE_MY_ORGANIZATION}?tab=practices`;
